import {
  gatewayRequest,
  gatewayUnparsedRequest,
  request,
  unparsedRequest,
} from './request';
const apiVersion = '/api/v4';

//для GET-запросов с параметрами
const prepareParams = (data: any) => {
  const params = new URLSearchParams();

  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      const value = data[key];

      if (Array.isArray(value)) {
        value.map((val) => params.append(key, val));
      } else {
        params.append(key, value);
      }
    }
  }

  return params;
};

export const API = {
  get: (
    url: string,
    id?: string,
    params?: any,
    extraHeaders?: { [key: string]: any }
  ) =>
    gatewayRequest(
      url + (id ? `${id}/` : '') + (params ? `?${prepareParams(params)}` : ''),
      {
        method: 'GET',
        credentials: 'include',
        headers: {
          'X-Time-Zone': Intl.DateTimeFormat().resolvedOptions().timeZone,
          // 'Content-Type': 'application/json;charset=utf-8',
          ...(extraHeaders && extraHeaders),
        },
      }
    ),
  gatewayUnparsedGet: (
    url: string,
    id?: string,
    params?: any,
    extraHeaders?: { [key: string]: any }
  ) =>
    gatewayUnparsedRequest(
      url + (id ? `${id}/` : '') + (params ? `?${prepareParams(params)}` : ''),
      {
        method: 'GET',
        credentials: 'include',
        headers: {
          'X-Time-Zone': Intl.DateTimeFormat().resolvedOptions().timeZone,
          'Content-Type': 'application/json;charset=utf-8',
          ...(extraHeaders && extraHeaders),
        },
      }
    ),
  // unparsedGet: (url: string, id?: string, params?: any) =>
  //   unparsedRequest(
  //     apiVersion +
  //       url +
  //       (id ? `${id}/` : '') +
  //       (params ? '?' + prepareParams(params) : ''),
  //     {
  //       method: 'GET',
  //       credentials: 'include',
  //     }
  //   ),
  // patch: (url: string, id?: string, params?: any) =>
  //   request(`${apiVersion}${url}${id ? `${id}/` : ''}`, {
  //     method: 'PATCH',
  //     headers: {
  //       'Content-Type': 'application/json;charset=utf-8',
  //     },
  //     credentials: 'include',
  //     body: params ? JSON.stringify(params) : undefined,
  //   }),
  gatewayPatch: (
    url: string,
    id?: string,
    params?: any,
    extraHeaders?: { [key: string]: any }
  ) =>
    gatewayRequest(`${url}${id ? `${id}/` : ''}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
        'X-Time-Zone': Intl.DateTimeFormat().resolvedOptions().timeZone,
        ...(extraHeaders && extraHeaders),
      },
      credentials: 'include',
      body: params ? JSON.stringify(params) : undefined,
    }),
  delete: (url: string, id?: string) =>
    gatewayRequest(`${url}${id ? `${id}/` : ''}`, {
      method: 'DELETE',
      credentials: 'include',
    }),
  gatewayDelete: (url: string, id?: string) =>
    gatewayRequest(`${url}${id ? `${id}/` : ''}`, {
      method: 'DELETE',
      credentials: 'include',
    }),
  // post: (url: string, body?: object) =>
  //   request(apiVersion + url, {
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'application/json;charset=utf-8',
  //     },
  //     credentials: 'include',
  //     body: body ? JSON.stringify(body) : undefined,
  //   }),
  gatewayPost: (
    url: string,
    body?: { [key: string]: any },
    extraHeaders?: { [key: string]: any }
  ) =>
    gatewayRequest(url, {
      method: 'POST',
      credentials: 'include',
      headers: {
        ...(body && {
          'Content-Type': 'application/json;charset=utf-8',
          'X-Time-Zone': Intl.DateTimeFormat().resolvedOptions().timeZone,
        }),
        ...(extraHeaders && extraHeaders),
        'X-Time-Zone': Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
      ...(body && { body: JSON.stringify(body) }),
    }),
  gatewayFilesPost: (url: string, body: FormData) =>
    gatewayRequest(url, {
      method: 'POST',
      credentials: 'include',
      body,
    }),
  put: (url: string, body?: object) =>
    gatewayRequest(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
        'X-Time-Zone': Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
      credentials: 'include',
      body: body ? JSON.stringify(body) : undefined,
    }),
  gatewayPut: (url: string, id?: string, body?: { [key: string]: any }) =>
    gatewayRequest(`${url}${id ? `${id}/` : ''}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
        'X-Time-Zone': Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
      credentials: 'include',
      body: body ? JSON.stringify(body) : undefined,
    }),
  patchFiles: (url: string, id: string, body: FormData) =>
    request(`${apiVersion}${url}${id}/`, {
      method: 'PATCH',
      // headers: {
      //   'Content-Type': 'multipart/form-data',
      // },
      credentials: 'include',
      body: body,
    }),
  patchFilesGtwy: (url: string, id?: string, body?: FormData) =>
    gatewayRequest(`${url}${id ? `${id}/` : ''}`, {
      method: 'PATCH',
      // headers: {
      //   'Content-Type': 'multipart/form-data',
      // },
      credentials: 'include',
      body,
    }),
  postFilesGtwy: (url: string, id?: string, body?: FormData) =>
    gatewayRequest(`${url}${id ? `${id}/` : ''}`, {
      method: 'POST',
      // headers: {
      //   'Content-Type': 'multipart/form-data',
      // },
      credentials: 'include',
      body: body,
    }),
  putFilesGtwy: (url: string, id?: string, body?: FormData) =>
    gatewayRequest(`${url}${id ? `${id}/` : ''}`, {
      method: 'PUT',
      // headers: {
      //   'Content-Type': 'multipart/form-data',
      // },
      credentials: 'include',
      body: body,
    }),
  postFiles: (url: string, body: FormData) =>
    request(`${apiVersion}${url}`, {
      method: 'POST',
      // headers: {
      //   'Content-Type': 'multipart/form-data',
      // },
      credentials: 'include',
      body: body,
    }),
  unparsedPost: (url: string, body: FormData) =>
    unparsedRequest(apiVersion + url, {
      method: 'POST',
      credentials: 'include',
      body: body,
      headers: {
        'X-Time-Zone': Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
    }),
};

type AbortableGetOptions = {
  params?: Record<string, unknown>;
  headers?: Record<string, string>;
  signal?: AbortSignal;
};

type AbortablePostOptions = {
  body?: Record<string, unknown>;
  headers?: Record<string, string>;
  signal?: AbortSignal;
};

export const AbortableAPI = {
  get: <T = unknown>(
    url: string,
    options: AbortableGetOptions = {}
  ): Promise<T> => {
    const { params, headers, signal } = options;

    return gatewayRequest(url + (params ? `?${prepareParams(params)}` : ''), {
      method: 'GET',
      credentials: 'include',
      signal,
      headers: {
        'X-Time-Zone': Intl.DateTimeFormat().resolvedOptions().timeZone,
        ...headers,
      },
    });
  },

  post: <T = unknown>(
    url: string,
    options: AbortablePostOptions = {}
  ): Promise<T> => {
    const { body, headers, signal } = options;

    return gatewayRequest(url, {
      method: 'POST',
      credentials: 'include',
      signal,
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
        'X-Time-Zone': Intl.DateTimeFormat().resolvedOptions().timeZone,
        ...headers,
      },
      ...(body && { body: JSON.stringify(body) }),
    });
  },

  postFiles: <T = unknown>(
    url: string,
    body: FormData,
    signal?: AbortSignal
  ): Promise<T> =>
    gatewayRequest(url, {
      method: 'POST',
      credentials: 'include',
      signal,
      body,
    }),

  put: <T = unknown>(
    url: string,
    options: AbortablePostOptions = {}
  ): Promise<T> => {
    const { body, headers, signal } = options;

    return gatewayRequest(url, {
      method: 'PUT',
      credentials: 'include',
      signal,
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
        'X-Time-Zone': Intl.DateTimeFormat().resolvedOptions().timeZone,
        ...headers,
      },
      ...(body && { body: JSON.stringify(body) }),
    });
  },

  patch: <T = unknown>(
    url: string,
    options: AbortablePostOptions = {}
  ): Promise<T> => {
    const { body, headers, signal } = options;

    return gatewayRequest(url, {
      method: 'PATCH',
      credentials: 'include',
      signal,
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
        'X-Time-Zone': Intl.DateTimeFormat().resolvedOptions().timeZone,
        ...headers,
      },
      ...(body && { body: JSON.stringify(body) }),
    });
  },

  delete: <T = unknown>(
    url: string,
    options: AbortablePostOptions = {}
  ): Promise<T> => {
    const { body, headers, signal } = options;

    return gatewayRequest(url, {
      method: 'DELETE',
      credentials: 'include',
      signal,
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
        'X-Time-Zone': Intl.DateTimeFormat().resolvedOptions().timeZone,
        ...headers,
      },
      ...(body && { body: JSON.stringify(body) }),
    });
  },

  postFilesGtwy: <T = unknown>(
    url: string,
    body: FormData,
    signal?: AbortSignal
  ): Promise<T> =>
    gatewayRequest(url, {
      method: 'POST',
      credentials: 'include',
      signal,
      body,
    }),
};

/**
 * Имитирует асинхронный запрос с задержкой.
 *
 * @param data - Данные, которые вернёт промис при успехе.
 * @param error - Если `true`, промис завершится с ошибкой.
 * @param timer - Задержка в миллисекундах.
 */
export const fetchMockData = async <T>(
  data: T,
  error: boolean = false,
  timer: number = 500
): Promise<T> => {
  return new Promise((resolve, reject) => {
    console.log('fetchMockData start');

    return setTimeout(() => {
      console.log('fetchMockData end');

      return error ? reject('fetchMockData error') : resolve(data);
    }, timer);
  });
};
